import React from "react";
import { formatCurrency } from "utils/string";
import * as Styled from "../styled";
import StatusTag from "../../../components/StatusTag";

interface Props {
  name: string;
  metadata: {
    result: boolean | string | number;
    userActionable?: boolean;
  };
}

const CriterionValue: React.FC<Props> = ({ name, metadata }) => {
  const { result: value, userActionable } = metadata;

  if (typeof value === "boolean") {
    return (
      <Styled.TagWrapper>
        <StatusTag status={value.toString()} />
        {userActionable !== undefined && (
          <StatusTag
            status={userActionable ? "user_actionable" : "not_user_actionable"}
          />
        )}
      </Styled.TagWrapper>
    );
  }

  if (name === "cashAdvanceScore") return value;

  if (typeof value === "number") {
    return formatCurrency(value, true);
  }

  return value;
};

export default CriterionValue;
